import React from "react";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import paths from "@icarius-router/paths";
import CommonPage from "@icarius-common/commonPage";
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import { getLocalizedString } from "@icarius-localization/strings";
import SelectionDialog from "@icarius-common/selectionDialog";
import useSocialBlacklist from "./useSocialBlacklist";

const SocialBlacklist = () => {

  const {
    isLoading,
    data,
    userList,
    state,
    handlers,
  } = useSocialBlacklist();

  const blockButton = () => (
    <CustomIconButton
      title={getLocalizedString("blockUser")}
      onClick={handlers.handleOpenUserSelectionDialog}
    >
      <LockIcon />
    </CustomIconButton>
  )

  const unlockButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("unblockUser")}
      onClick={() => handlers.handleOpenDeleteDialog(gridRef)}
    >
      <LockOpenIcon />
    </CustomIconButton>
  )

  return (
    <CommonPage
      isLoading={isLoading}
      title={getLocalizedString("socialBlacklist")}
      gridTitle={getLocalizedString("socialBlacklist")}
      columnDefPage={paths.socialBlacklist}
      rowData={data}
      menuItems={[blockButton, unlockButton]}
      hasExpand
      hasHelp
    >
      {
        state.userSelectionDialogIsOpen &&
        <SelectionDialog
          open={state.userSelectionDialogIsOpen}
          items={userList.map((item) => ({ ...item, key: item.code, value: item.name }))}
          getItemAvatar={(item) => item.image}
          title={getLocalizedString("selectUserToBlock")}
          selectedTitle={getLocalizedString("selectedUser")}
          handleClose={handlers.handleCloseUserSelectionDialog}
          handleSubmit={(data) => handlers.handleBlockUser(data[0])}
          singleSelection
          required
        />
      }
    </CommonPage>
  )
}

export default SocialBlacklist;